import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import FocusLock from 'react-focus-lock';
import keyboardKey from 'keyboard-key';
import messages from '../messages';

import '../styles.css';

const LocationList = ({
  locations,
  focusLock,
  setLocationEdit,
  onLocationSelected,
  onClosePopup,
}) => {
  useEffect(() => {
    if (focusLock) return;
    document.querySelector('#locationsPopup ul li:nth-child(1) > button').focus();
  }, [focusLock]);

  const onKeyDownRow = (event, index, location, type) => {
    const code = keyboardKey.getCode(event);

    switch (code) {
      case keyboardKey.ArrowUp: {
        if (index === 0) {
          document.querySelector(`#locationsPopup ul li:nth-child(${locations.length + 1}) > button`).focus();
          setTimeout(() => {
            document.querySelector(`#locationsPopup ul li:nth-child(${locations.length + 1}) > button`).scrollIntoView();
          }, 50);
          return;
        }

        if (index === (locations.length + 1) && locations.length !== 0) {
          document.querySelector(`#locationsPopup ul li:nth-child(${locations.length}) > button`).focus();
          return;
        }

        document.querySelector(`#locationsPopup ul li:nth-child(${index}) > button`).focus();
        break;
      }
      case keyboardKey.ArrowDown: {
        if (index === (locations.length + 1)) {
          document.querySelector('#locationsPopup ul li:nth-child(1) > button').focus();
          setTimeout(() => {
            document.querySelector('#locationsPopup ul li:nth-child(1) > button').scrollIntoView();
          }, 50);
          return;
        }
        document.querySelector(`#locationsPopup ul li:nth-child(${index + 2}) > button`).focus();
        break;
      }

      case keyboardKey.ArrowRight: {
        if (index === (locations.length + 1)) return;
        document.querySelector(`#locationsPopup ul li:nth-child(${index + 1}) > button:nth-child(2)`).focus();
        break;
      }

      case keyboardKey.ArrowLeft: {
        if (index === (locations.length + 1)) return;
        document.querySelector(`#locationsPopup ul li:nth-child(${index + 1}) > button`).focus();
        break;
      }

      case keyboardKey.Enter: {
        if (type === 'row') {
          onLocationSelected(location);
        } else {
          setLocationEdit(location);
        }
        break;
      }

      case keyboardKey.Escape: {
        onClosePopup();
        break;
      }
    }
  };

  const renderLocation = (location, index) => (
    <li role="option" aria-selected key={location.id}>
      <button
        aria-label={`Select Location, 
          Name ${location.name}, 
          Address ${location.street} ${location.city}, ${location.state}, ${location.postalCode}`}
        type="button"
        styleName="title-button"
        onClick={() => onLocationSelected(location)}
        onKeyDown={(event) => onKeyDownRow(event, index, location, 'row')}
      >
        <span
          tabIndex="-1"
          styleName="location-title"
        >
          {location.name}
        </span>
        <span
          tabIndex="-1"
          styleName="location-detail"
        >
          {location.street} {location.city}{','} {location.state}{','} {location.postalCode}
        </span>
      </button>
      <button
        aria-label={`Edit Location for ${location.name}`}
        type="button"
        styleName="edit-button"
        onClick={() => setLocationEdit(location)}
        onKeyDown={(event) => onKeyDownRow(event, index, location, 'edit')}
      >
        <FormattedMessage id="collegeevents.location.edit" {...messages.editLocation} />
      </button>
    </li>
  );

  return (
    <FocusLock returnFocus autoFocus disabled={focusLock}>
      <ul id="location-list" styleName="location-list">
        {locations.map(renderLocation)}
        <li>
          <button
            data-cy="new-location-button"
            type="button"
            styleName="title-button new-button"
            onClick={() => setLocationEdit()}
            onKeyDown={(event) => onKeyDownRow(event, locations.length + 1, null, 'new')}
          >
            <FormattedMessage id="collegeevents.location.new" {...messages.newLocation} />
          </button>
        </li>
      </ul>
    </FocusLock>
  );
};

LocationList.propTypes = {
  locations: PropTypes.array.isRequired,
  focusLock: PropTypes.bool,
  setLocationEdit: PropTypes.func.isRequired,
  onLocationSelected: PropTypes.func.isRequired,
  onClosePopup: PropTypes.func.isRequired,
};

export default LocationList;
